<div class="circle">
  <span class="initials">{{text}}</span>
</div>
